export default function Industries() {
  const industries = [
    {
      icon: 'ri-building-4-line',
      title: 'Construction & Real Estate',
      description: 'Delivering world-class residential, commercial, and infrastructure projects with precision and quality'
    },
    {
      icon: 'ri-earth-line',
      title: 'Mining & Natural Resources',
      description: 'Sustainable extraction and processing of minerals with advanced technology and environmental responsibility'
    },
    {
      icon: 'ri-vip-diamond-line',
      title: 'Precious Gems & Jewellery',
      description: 'Sourcing, designing, and trading exquisite gems and jewellery for global markets'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Corporate Advisory',
      description: 'Strategic consulting and investment advisory services for business growth and compliance'
    }
  ];

  return (
    <section id="industries" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Diversified expertise across multiple sectors, driving growth and innovation
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center group hover:-translate-y-2"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className={`${industry.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{industry.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{industry.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}